import React from 'react'
import {
    StyledActionLink,
    usernameButtonClassname,
    StyledActionTextUsername,
} from './TheWestHeaderLogin.styled'

export const UserNameLink: React.FC<{ userName: string }> = ({ userName }) => {
    return (
        <StyledActionTextUsername>
            Hi{' '}
            <StyledActionLink
                className={usernameButtonClassname}
                to={'https://subscriber.thewest.com.au/myaccount'}
                rel="noopener"
                openExternalInNewWindow={true}
                isPrimary={false}
            >
                {userName}
            </StyledActionLink>
        </StyledActionTextUsername>
    )
}
